import React, { Component, useState } from "react";
import { graphql } from "gatsby";
import styled, { css } from "styled-components";
import Img from "gatsby-image";
import axios from "axios";
import {
  Row,
  Col,
  Gap,
  Text as TextContent,
  Section,
  Title,
  Button,
  VH,
  SEO,
  TextField,
} from "../components";
import { up } from "../lib/styles";
import Link from "../components/Link";
import links from "../lib/links";

const TextComponent = (props) => (
  <TextContent fontWeight="400" fontSize="22px" lineHeight="30px" {...props} />
);
const Text = styled(TextComponent)`
  ${({ noMargin }) =>
    css`
      margin-bottom: ${noMargin ? "0" : "24px"};
    `}
`;

const CONTAINER_WIDTH = "1000px";

const PageWrapper = styled.div`
  position: relative;
  min-height: calc(min(100vw, 1920px) * (2362 / 1920));
`;

const BLink = styled(Link)`
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`;

const BLinkBlank = styled.a.attrs(() => ({
  target: "_blank",
  rel: "noopener noreferrer",
}))`
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`;
const BBBP = 770;

const validateEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const lightBlue = "#a7cbeb";
const lighterLightBlue = "#d2e7f8";
const darkBlue = "#1d3b70";
const lighterDarkBlue = "#376190";
const yellow = "#f6ee24";

const StyledOuterBox = styled.div`
  ${({ theme: { colors }, dark }) => css`
    background: ${dark ? lighterDarkBlue : lighterLightBlue};
  `}
`;

const StyledInnerBox = styled.div`
  ${({ theme: { colors }, dark }) => css`
    background: ${dark ? darkBlue : lightBlue};
  `}
  display: block;
  padding: 30px 28px;
  width: 100%;

  /* max-width: 400px; */
  ${up("tinyMobile")} {
    width: 90%;
  }

  ${up("mobile")} {
    /* max-width: 500px; */
    padding: 40px 40px;
    width: 80%;
  }
  ${up(BBBP)} {
    max-width: 1250px;
    width: 100%;
  }

  ${up("tablet")} {
    padding: 50px 70px;
  }
  ${up(1050)} {
    width: 85%;
  }
`;

const InvestTitle = (props) => (
  <Title.Big
    innerAs="h2"
    fontWeight="400"
    fontSize="38px"
    lineHeight="1.2"
    style={{ textTransform: "uppercase" }}
    black
    {...props}
  />
);
const InvestTitleGap = () => <Gap gap="24px" mobileGap="16px" />;

const InvestSubtitle = (props) => (
  <Title.Small
    innerAs="h3"
    // fontWeight="400"
    // style={{ textTransform: "uppercase" }}
    black
    {...props}
  />
);

const BlueBoxItem = ({ image, title, children, alt, maxWidth = "250px" }) => (
  <Col width="100%" maxWidth={maxWidth}>
    <Col maxWidth="220px">
      <Img fluid={image.image.fluid} alt={alt} />
    </Col>
    <Gap gap="16px" />
    <Text>{title}</Text>
    {children}
  </Col>
);
const BlueBoxTitle = (props) => <Title.Small innerAs="h3" black {...props} />;
const BlueBoxTitleLink = ({ href, to, ...props }) => {
  const LinkComponent = href ? BLinkBlank : BLink;
  const linkProps = href ? { href } : { to };
  return (
    <BlueBoxTitle>
      <LinkComponent {...linkProps} {...props} />
    </BlueBoxTitle>
  );
};

const BBRow = (props) => (
  <>
    <Gap gap="50px" mobileGap="28px" bp="tablet" />
    <Row {...props} justifyContent="space-between" responsive bp={BBBP} />
  </>
);

const BBWhiteText = (props) => (
  <Text white gray={false} fontWeight="400" {...props} />
);

const TextList = styled.ul`
  font-size: 22px;
  color: ${({ black }) => (black ? "#000" : "#8d8d8f")};
  padding-left: 20px;
  list-style: disc;
  margin-top: 8px;
  margin-bottom: 32px;
  li {
    line-height: 1.35;
    padding: 5px 0;
  }

  ${({ noMargin }) =>
    noMargin &&
    css`
      margin-bottom: 0;
    `}

  ${up("tablet")} {
    padding-left: 48px;
  }
`;

const BBList = styled.ul`
  font-size: 20px;
  padding-left: 20px;
  li {
    line-height: 1.35;
  }

  ${up("mobile")} {
    font-size: 22px;
  }
`;
const BBGap = () => <Gap gap="28px" />;
const BBTextField = styled(TextField)`
  ::placeholder {
    color: #3157a6;
  }
`;

const FormHelperText = styled.p`
  font-size: 16px;
  line-height: 1.4;
  color: #8d8d8f;
  margin: 12px 0 0;
`;

const ProgressBarOuter = styled.div`
  ${({ theme: { colors }, progress }) => css`
    background: ${yellow};
    height: 6px;
    width: 100%;
    position: relative;

    &:before {
      content: "€0";
      position: absolute;
      top: 14px;
      left: 0;
      font-size: 16px;
      color: white;
      transform: translateX(-50%);
    }
    &:after {
      content: "€1,500,000";
      font-size: 16px;
      position: absolute;
      top: 14px;
      right: 0;
      color: white;
      transform: translateX(25%);
      ${up("mobile")} {
        transform: translateX(50%);
      }
    }
  `}
`;
const ProgressBarInner = styled.div`
  ${({ progress }) => css`
    position: absolute;
    top: 0;
    left: 0;
    width: ${progress}%;
    height: 100%;
    background: ${lighterDarkBlue};
    &:after {
      content: "€1,300,000";
      font-size: 16px;
      position: absolute;
      top: -22px;
      right: 0;
      color: white;
      transform: translateX(25%);
      ${up("tablet")} {
        top: 14px;
        transform: translateX(50%);
      }
    }
  `}
`;

const TopImageSection = styled(Section)`
  position: absolute;
  bottom: 32px;
  left: 0;
  width: 100%;
  max-width: unset;
  padding: 0 20px;
  ${up("mobile")} {
    bottom: 80px;
  }
  ${up("tablet")} {
    padding: 0 24px;
  }
`;

const TextLink = styled.a`
  text-decoration: underline;
  color: #000;
  &:hover {
    text-decoration: none;
  }
`;

const ListLink = styled.a.attrs(() => ({
  target: "_blank",
  rel: "noopener noreferrer",
}))`
  text-decoration: underline;
  color: #8d8d8f;
  &:hover {
    text-decoration: none;
  }
`;

const Quote = styled.blockquote`
  font-style: italic;
  max-width: 760px;
  margin: 0 auto;

  strong {
    color: #000;
    font-style: normal;
  }
`;

const TopImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(0, 0, 0, 0.3);
  ${up("tablet")} {
    background: rgba(0, 0, 0, 0.3);
  }
  ${up("desktop")} {
    background: rgba(0, 0, 0, 0.2);
  }
  ${up("largeDesktop")} {
    background: rgba(0, 0, 0, 0);
  }
`;

const ProgressBar = ({ progress }) => (
  <ProgressBarOuter>
    <ProgressBarInner progress={progress} />
  </ProgressBarOuter>
);

const InvestForm = ({ fieldOnly }) => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSent, setIsSent] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const onEmailSend = async () => {
    if (isSending) return;
    if (!email) return setErrorMessage("Email is required");
    if (!validateEmail(email)) return setErrorMessage("Email is not valid");
    setIsSending(true);

    try {
      await axios.post("/api/v1/investor-contact", {
        email: email.trim(),
      });
      setIsSending(false);
      setIsSent(true);

      setEmail("");
      setErrorMessage("");
    } catch (error) {
      setIsSending(false);

      setErrorMessage("");
      setTimeout(
        // call after ui update
        () => alert("Sending failed"),
        1,
      );
    }
  };

  if (isSent) {
    const thankYouText = "Thank you, we will contact you soon.";
    return !fieldOnly ? (
      <BBWhiteText>{thankYouText}</BBWhiteText>
    ) : (
      <Text fontWeight="400">{thankYouText}</Text>
    );
  }
  return (
    <>
      {!fieldOnly && (
        <>
          <BBWhiteText>Get more information:</BBWhiteText>
          <Gap gap="12px" mobileGap="12px" />
        </>
      )}
      <Row responsive maxWidth="600px">
        <BBTextField
          width="100%"
          placeholder="Your email"
          value={email}
          onChange={({ target }) => setEmail(target.value)}
          required
          hasError={!!errorMessage}
          error={errorMessage}
          onBlur={() => setErrorMessage("")}
          style={{ border: "3px solid #3157a6", color: "#3157a6" }}
          ErrorComponent={Text.ErrorInvest}
        />
        <Gap gap="8px" mobileGap="20px" />
        <Button.SubmitInvestForm onClick={onEmailSend}>
          SUBMIT
        </Button.SubmitInvestForm>
      </Row>

      {fieldOnly && (
        <FormHelperText>
          Leave your email to receive the deck and round details. We respond
          within two business days.
        </FormHelperText>
      )}

      {!fieldOnly && (
        <>
          <Gap gap="16px" />

          <BBWhiteText>
            Leave us your contact and we’ll send the information package.
          </BBWhiteText>
        </>
      )}
    </>
  );
};

const ImagesBlock = ({
  image1,
  image2,
  image3,
  image1Alt,
  image2Alt,
  image3Alt,
}) => (
  <Row
    justifyContent="space-evenly"
    mobileJustifyContent="center"
    alignItems="flex-end"
    mobileAlignItems="center"
    width="100%"
    margin="auto"
    mobileFlexDirection="column"
  >
    <Col width="100%">
      <Img fluid={image1.image.fluid} alt={image1Alt} />
    </Col>
    <Gap gap="16px" />
    <Col width="100%">
      <Img fluid={image2.image.fluid} alt={image2Alt} />
    </Col>
    <Gap gap="16px" />
    <Col width="100%">
      <Img fluid={image3.image.fluid} alt={image3Alt} />
    </Col>
  </Row>
);

const SectionGap = () => <Gap gap="80px" mobileGap="40px" />;

class Invest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSent: false,
      email: "",
      errorMessage: "",
      isMobile: false,
    };
  }

  updateIsMobile = () => {
    if (typeof window === "undefined") return;
    const isMobile = window.innerWidth < 768;
    if (this.state.isMobile !== isMobile) {
      this.setState({ isMobile });
    }
  };

  componentDidMount() {
    this.updateIsMobile();
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.updateIsMobile);
    }
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.updateIsMobile);
    }
  }

  onEmailSend = async () => {
    const { email } = this.state;
    if (!email) return this.setState({ errorMessage: "Email is required" });
    if (!validateEmail(email))
      return this.setState({ errorMessage: "Email is not valid" });
    this.setState({ isSent: true });

    try {
      await axios.post("/api/v1/investor-contact", {
        email: email.trim(),
      });
      this.setState({ email: "", errorMessage: "" });
    } catch (error) {
      this.setState({ isSent: false, errorMessage: "" });
      setTimeout(
        // call after ui update
        () => alert("Sending failed"),
        1,
      );
    }
  };

  render() {
    const { isMobile } = this.state;

    const {
      location: { pathname },
      data: {
        topImage,
        demonstratorImage,
        demonstratorImageMobile,
        passenger2Image,
        cargo2Image,
        sar3Image,
      },
    } = this.props;

    const investSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Zuri",
      industry: "Aerospace",
      country: "Czech Republic",
      product: "Zuri Hybrid VTOL",
      funding: "Series A",
    };
    return (
      <PageWrapper>
        <SEO
          title="Invest in Zuri Hybrid VTOL | Series A Open | Zuri"
          description="Invest in Zuri, a Czech aerospace company developing the hybrid-electric Zuri Hybrid VTOL. The privately funded program is opening its Series A round following TD 2.0 at AERO Friedrichshafen 2026."
          ogTitle="Invest in Zuri — Series A Open"
          ogDescription="Zuri is opening its Series A round to fund Technology Demonstrator 2.0 completion, flight testing, and continued development toward the final hybrid VTOL aircraft."
          pathname={pathname}
          schema={investSchema}
          ogImageUrl="/share/zuri-hybrid-vtol-urban-landing-city-waterfront-passenger-arrival.jpg"
        />
        <Gap.Top />

        <Col width="100%" position="relative">
          <TopImageOverlay />
          <Img
            fluid={topImage.image.fluid}
            alt="Zuri Hybrid VTOL aircraft hovering above a city waterfront landing zone with passengers onboard, illustrating urban air mobility and real-world infrastructure integration"
            loading="eager"
          />
          <TopImageSection>
            <div className="top-image-overlay" />
            <Row width="100%">
              <Col maxWidth={CONTAINER_WIDTH} width="100%" margin="auto">
                <Title.Big
                  innerAs="h1"
                  fontWeight="400"
                  style={{ textTransform: "uppercase" }}
                  white
                  black={false}
                >
                  INVEST IN ZURI
                </Title.Big>
              </Col>
            </Row>
          </TopImageSection>
        </Col>

        <Section background="white">
          <Gap gap="100px" mobileGap="40px" />

          <Row maxWidth={CONTAINER_WIDTH} margin="auto">
            <Col>
              <InvestTitle as="h2">Zuri Hybrid VTOL</InvestTitle>
              <InvestTitleGap />
              <Text>
                Zuri is a Czech aerospace company developing the Zuri Hybrid
                VTOL, a hybrid-electric aircraft combining vertical takeoff with
                efficient wing-borne cruise. It is designed for regional
                missions underserved by current transport options.
              </Text>
              <Text noMargin>
                The program is privately funded, with multiple investment rounds
                completed since 2018.
              </Text>
              <SectionGap />
              <InvestTitle as="h2">Series A Investment — Open</InvestTitle>
              <InvestTitleGap />
              <Text>Zuri is opening its Series A round.</Text>
              <Text noMargin>
                Following the public debut of{" "}
                <TextLink href="https://zuri.com/technology/td-2-0-hybrid-vtol-demonstrator">
                  Technology Demonstrator 2.0
                </TextLink>{" "}
                (TD 2.0) at AERO Friedrichshafen 2026, this round funds its
                completion, the flight test campaign in late 2026 and early
                2027, and continued work toward the final aircraft.
              </Text>
              <Gap gap="48px" />
            </Col>
          </Row>
        </Section>

        {!isMobile && (
          <Img
            fluid={demonstratorImage.image.fluid}
            alt="Zuri Hybrid VTOL aircraft render showing passenger configuration and cargo transport use case"
          />
        )}

        {isMobile && (
          <Img
            fluid={demonstratorImageMobile.image.fluid}
            alt="Zuri Hybrid VTOL aircraft render showing passenger configuration and cargo transport use case"
          />
        )}
        <Section background="white">
          <Row maxWidth={CONTAINER_WIDTH} margin="auto">
            <Col>
              <Gap gap="48px" />
              <Text>
                TD 2.0 integrates propulsion, energy management, electrical
                power distribution, and tiltrotor assemblies in a representative
                configuration. Test results inform final aircraft design and
                align with anticipated certification requirements.
              </Text>
              <Text noMargin>
                To discuss the round, ask questions, or arrange a private
                introduction, write to{" "}
                <TextLink href="mailto:investor@zuri.com">
                  investor@zuri.com
                </TextLink>
                .
              </Text>
              <SectionGap />
              <InvestTitle as="h2">Why Invest?</InvestTitle>
              <Gap gap="16px" />
              <TextList black noMargin>
                <li>
                  <strong>DEMONSTRATED FLIGHT</strong> Full-scale TD 1.0 flight
                  tested under Czech LCAA oversight, with 15+ subscale aircraft
                  flown including transition.
                </li>
                <li>
                  <strong>HYBRID-ELECTRIC RANGE</strong> Seven times the usable
                  range of all-electric eVTOLs, with SAF compatibility on the
                  turbine.
                </li>
                <li>
                  <strong>MISSION VERSATILITY</strong> Passenger, cargo, medical,
                  and public safety missions in a single airframe, at lower cost
                  and lower noise than rotorcraft.
                </li>
                <li>
                  <strong>ATTRACTIVE VALUATION</strong> Entry pricing remains a
                  fraction of US peers Joby and Archer, with material upside as
                  the program approaches TD 2.0 flight.
                </li>
                <li>
                  <strong>EXPERIENCED TEAM</strong> Eight years of hybrid VTOL
                  development with in-house propulsion, tiltrotor integration,
                  and Czech aerospace engineering depth.
                </li>
              </TextList>
              <SectionGap />
              <InvestTitle as="h2">Request Investor Materials</InvestTitle>
              <InvestTitleGap />
              <InvestForm fieldOnly />
              <SectionGap />
            </Col>
          </Row>
        </Section>
        <Section background={lighterLightBlue}>
          <Row maxWidth={CONTAINER_WIDTH} margin="auto">
            <Col>
              <SectionGap />
              <InvestTitle as="h2">Aircraft Development Status</InvestTitle>
              <InvestTitleGap />
              <Text black>
                The Zuri program has progressed from concept through full-scale
                flight test, and is in integrated aircraft build.
              </Text>
              <Text black noMargin>
                Achieved to date:
              </Text>
              <TextList black>
                <li>Aircraft architecture defined</li>
                <li>Hybrid propulsion and energy management developed</li>
                <li>Subsystems validated through bench testing</li>
                <li>
                  TD 1.0 demonstrator flight tested (11m wingspan, Czech LCAA
                  oversight)
                </li>
                <li>15+ subscale aircraft flown, including transition</li>
                <li>Prague R&D and integration facility opened</li>
                <li>TD 2.0 unveiled at AERO Friedrichshafen 2026</li>
              </TextList>
              <Text black>TD 2.0 is in active build and integration.</Text>
              <Text black noMargin>
                This round accelerates the program to TD 2.0 first flight:
              </Text>
              <TextList black noMargin>
                <li>Completion of build and integration</li>
                <li>Ground testing</li>
                <li>
                  Flight test campaign (targeted for late 2026 or early 2027)
                </li>
                <li>Continued development toward the final aircraft</li>
              </TextList>
              <SectionGap />
            </Col>
          </Row>
        </Section>
        <Section background="white">
          <Row maxWidth={CONTAINER_WIDTH} margin="auto">
            <Col>
              <SectionGap />
              <InvestTitle as="h2">
                Investors and Commercial Interest
              </InvestTitle>
              <InvestTitleGap />
            </Col>
          </Row>

          <Row maxWidth={CONTAINER_WIDTH} margin="auto">
            <Col>
              <InvestSubtitle as="h3">
                Institutional and corporate backers
              </InvestSubtitle>
              <TextList>
                <li>
                  <ListLink href="https://palefirecapital.com/en/">
                    Pale Fire Capital
                  </ListLink>
                </li>
                <li>
                  <ListLink href="https://www.kiwi.com/">Kiwi.com</ListLink>
                </li>
                <li>
                  <ListLink href="https://www.keenswh.com/">
                    Keen Software House
                  </ListLink>
                </li>
              </TextList>
              <InvestSubtitle as="h3">Individual investors</InvestSubtitle>
              <TextList>
                <li>
                  <ListLink href="https://www.linkedin.com/in/jaroslavbeck/">
                    Jaroslav Beck
                  </ListLink>
                </li>
                <li>
                  <ListLink href="https://www.linkedin.com/in/obartos/">
                    Ondřej Bartoš
                  </ListLink>
                </li>
                <li>
                  <ListLink href="https://www.linkedin.com/in/janhabermann/">
                    Jan Habermann
                  </ListLink>
                </li>
                <li>
                  <ListLink href="https://www.linkedin.com/in/synopsi/">
                    Rasty Turek
                  </ListLink>
                </li>
                <li>
                  <ListLink href="https://www.linkedin.com/in/nesetril">
                    Jakub Nešetřil
                  </ListLink>
                </li>
                <li>
                  <ListLink href="https://www.linkedin.com/in/borisrenski/">
                    Boris Renski
                  </ListLink>
                </li>
                <li>
                  <ListLink href="https://www.linkedin.com/in/danielmajewski/">
                    Daniel Majewski
                  </ListLink>
                </li>
                <li>
                  <ListLink href="https://www.linkedin.com/in/mat%C4%9Bj-turek-cfa-a450078a/">
                    Matěj Turek
                  </ListLink>
                </li>
              </TextList>

              <InvestSubtitle as="h3">Commercial interest</InvestSubtitle>
              <Gap gap="16px" />
              <Text noMargin>
                More than 30 letters of intent signed with prospective operators
                across multiple regions and use cases.
              </Text>

              <SectionGap />

              <InvestTitle as="h2">Markets and Applications</InvestTitle>
              <InvestTitleGap />
              <Text>
                The Zuri Hybrid VTOL serves routes and missions beyond the reach
                of conventional aviation.
              </Text>
              <InvestSubtitle>Infrastructure flexibility</InvestSubtitle>
              <Gap gap="16px" />
              <Text>
                Operates from vertiports and other aviation facilities. No
                airline-scale airport infrastructure required.
              </Text>
              <InvestSubtitle>Regional connectivity</InvestSubtitle>
              <Gap gap="16px" />
              <Text>
                Connects regions where conventional aviation is limited by
                infrastructure, cost, or routing.
              </Text>
              <InvestSubtitle>Operational use</InvestSubtitle>
              <Gap gap="16px" />
              <Text>
                Built for routine regional missions with consistent utilization,
                scheduled or on-demand.
              </Text>
              <InvestSubtitle>Use cases</InvestSubtitle>
              <TextList noMargin>
                <li>Passenger transport</li>
                <li>Business and professional travel</li>
                <li>Time-critical and high-value cargo</li>
                <li>Emergency and medical response</li>
                <li>Public safety and government support operations</li>
              </TextList>
              <SectionGap />
            </Col>
          </Row>
        </Section>

        <Section.Simple>
          <ImagesBlock
            image1={passenger2Image}
            image2={cargo2Image}
            image3={sar3Image}
            image1Alt="Business traveler walking toward a Zuri Hybrid VTOL at a terminal."
            image2Alt="Ground crew loading low-emission cargo into a Zuri Hybrid VTOL aircraft."
            image3Alt="Rescue crew hoisting an injured person into a Zuri Hybrid VTOL during mountain mission."
          />
        </Section.Simple>

      </PageWrapper>
    );
  }
}

export default Invest;

export const pageQuery = graphql`
  fragment PreviewImage on File {
    image: childImageSharp {
      fluid(maxWidth: 220, quality: 80) {
        ...GatsbyImageSharpFluid_withWebp
      }
    }
  }
  query {
    passenger2Image: file(
      relativePath: {
        eq: "images/usage/passenger/zuri-hybrid-vtol-passenger-business-terminal.jpg"
      }
    ) {
      ...UsesImage
    }
    cargo2Image: file(
      relativePath: {
        eq: "images/usage/cargo/zuri-hybrid-vtol-cargo-loading-ground-handling.jpg"
      }
    ) {
      ...UsesImage
    }
    sar3Image: file(
      relativePath: {
        eq: "images/usage/SAR/zuri-hybrid-vtol-mountain-rescue-hoist-operation.jpg"
      }
    ) {
      ...UsesImage
    }

    demonstratorImage: file(
      relativePath: {
        eq: "images/invest/zuri-demonstrator-2-hybrid-electric-vtol-aircraft.jpg"
      }
    ) {
      ...FullHdImage
    }

    demonstratorImageMobile: file(
      relativePath: {
        eq: "images/invest/zuri-demonstrator-2-hybrid-electric-vtol-aircraft.mobile.jpg"
      }
    ) {
      ...FullImageMobile
    }

    topImage: file(
      relativePath: {
        eq: "images/invest/zuri-hybrid-vtol-urban-landing-city-waterfront-passenger-arrival.jpg"
      }
    ) {
      image: childImageSharp {
        fluid(maxWidth: 1920, quality: 80) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;
